export enum ReimbursementTypeEnum {
    INDENNITA_CHILOMETRICA = 'INDENNITA_CHILOMETRICA',
    ALLOGGIO = 'ALLOGGIO',
    VITTO = 'VITTO',
    ALTRO = 'ALTRO',
    PEDAGGIO = 'PEDAGGIO',
    TRAGHETTO = 'TRAGHETTO',
    PARCHEGGIO = 'PARCHEGGIO',
    SERVIZI_POSTALI = 'SERVIZI_POSTALI'
}

export enum PaymentTypeEnum {
    TRACCIATO = 'TRACCIATO',
    NON_TRACCIATO = 'NON_TRACCIATO'
}

export enum UsedVehicleEnum {
    AEREO = 'AEREO',
    TRENO = 'TRENO',
    BUS = 'BUS',
    ALTRO = 'ALTRO'
}

export enum CarTypeEnum {
    AUTO_DI_PROPRIETA = 'AUTO_DI_PROPRIETA',
    AUTO_A_NOLEGGIO = 'AUTO_A_NOLEGGIO',
    AUTO_DELLA_SOCIETA = 'AUTO_DELLA_SOCIETA'
}

export enum ProformaStatusEnum {
    DA_VALIDARE = 'DA_VALIDARE',
    VALIDATA = 'VALIDATA',
    NON_VALIDATA = 'NON_VALIDATA'
}

export interface createProformaDTO {
    inspectionVisitIds: string[]
    assignmentId?: string
    fiscalRegime?: string
}

export interface IVReimbursementDTO {
    id?: string
    inspectionVisitIds: string[]
    assignmentId?: string
    inspectorCode?: string
    reimbursementType?: ReimbursementTypeEnum
    paymentType?: PaymentTypeEnum
    amount?: number
    note?: string
    usedVehicle?: UsedVehicleEnum
    carModel?: string
    carNumberPlate?: string
    carType?: CarTypeEnum
    day?: Date
    departurePlace?: string
    arrivalPlace?: string
    returnPlace?: string
    kilometresTravelled?: number
}

export interface GetAllIVReimbursementDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: IVReimbursementDTO[]
}

export interface GetAllIVReimbursementFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    inspectionVisitId?: string
    assignmentId?: string
}

export interface GetAllProformaFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    assignmentId?: string
    year?: string
}

export interface GetAllProformaResponseDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: GetAllProformaDataResponseDTO[]
}

export interface GetAllProformaDataResponseDTO {
    id?: string
    assignmentId?: string
    year?: string
    inspectionVisitIds?: string[]
    creationDate: string
    status: ProformaStatusEnum
}

export interface IVReimbursementAssignmentEstimatedCostDTO {
    kilometresTotalCosts: number
    alloggioTotalCosts: number
    vittoTotalCosts: number
    otherTotalCosts: number
    pedaggioTotalCosts: number
    traghettoTotalCosts: number
    parcheggioTotalCosts: number
    postalTotalCosts: number
    totalReimbursementRequests: number
    totalReimbursementVisits: number
    totalCosts: number
}

export interface UpdateProformaDTO {
    status?: string
    invoiceNumber?: string
    invoiceDate?: Date
    invoiceProtocolId?: string
}